import { List, Map } from 'immutable'
import i18next from 'i18next'
import wopiService from '../services/wopi'

const RESET_QUESTIONNAIRE = 'questionnaire/RESET'
const FETCH_QUESTIONNAIRE = 'questionnaire/FETCH'
const FETCH_QUESTIONS_TRANSLATIONS = 'questionnaire/FETCH_TRANSLATIONS'
const START_QUESTIONNAIRE = 'questionnaire/START'
const ANSWER_QUESTION = 'questionnaire/ANSWER'
const PRE_ANSWER_QUESTION = 'questionnaire/PRE_ANSWER'
const NEXT_PHASE = 'questionnaire/NEXT_PHASE'
const SUBMIT_PERSONAL_INFORMATION = 'questionnaire/PERSONAL_INFORMATION'
const QUESTIONNAIRE_ERROR = 'questionnaire/ERROR'

const defaultState = Map({
  isLoading: true,
  questionnaireUuid: null,
  questions: List(),
  activeQuestionIndex: 0,
  activeSetupPhase: 0,
  personalInformation: null,
  language: null,
  isStarted: null,
  activeQuestionAnswer: null,
  isTranslationReady: false,
  error: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case RESET_QUESTIONNAIRE:
      return defaultState

    case FETCH_QUESTIONNAIRE:
      if (!action.payload) {
        return state.update('language', language => 'en').update('isLoading', isLoading => false)
      }

      return state
        .update('questionnaireUuid', questionnaireUuid => List(action.payload.uuid))
        .update('activeQuestionIndex', index => action.payload.activeQuestionIndex)
        .update('questions', questions => List(action.payload.answers))
        .update('personalInformation', index => action.payload.personalInformation)
        .update('language', index => action.payload.defaultLanguage)
        .update('isStarted', index => !!action.payload.startedAt)
        .update('isLoading', isLoading => false)
        .update('isFinished', isFinished => !!action.payload.finishedAt)

    case FETCH_QUESTIONS_TRANSLATIONS:
      return state
        .update('isTranslationReady', isReady => action.payload.isReady)
        .update('language', language => action.payload.language)

    case PRE_ANSWER_QUESTION:
      return state.update('activeQuestionAnswer', activeAnswer => action.payload)

    case ANSWER_QUESTION:
      return state
        .update('questions', questions => action.payload.questions)
        .update('activeQuestionAnswer', isAnswered => null)
        .update('activeQuestionIndex', index => action.payload.activeQuestionIndex)

    case NEXT_PHASE:
      return state.update('activeSetupPhase', phase => phase + 1)

    case START_QUESTIONNAIRE:
      return state.update('isStarted', isStarted => true)

    case QUESTIONNAIRE_ERROR:
      return state.update('error', error => action.payload)

    default:
      return state
  }
}

export function resetQuestionnaire() {
  return dispatch => {
    dispatch({ type: RESET_QUESTIONNAIRE })
  }
}

export function fetchQuestionnaire(uuid) {
  return dispatch => {
    return wopiService
      .getWopi(uuid)
      .then(response => dispatch({ type: FETCH_QUESTIONNAIRE, payload: response.data }))
      .catch(() => dispatch({ type: FETCH_QUESTIONNAIRE }))
  }
}

export function fetchTranslationsForQuestions(language) {
  return dispatch => {
    wopiService
      .getTranslationsForWopiQuestions(language)
      .then(response => {
        i18next.addResourceBundle(language, 'questions', response.data.questions)
        i18next.addResourceBundle(language, 'questionnaire', response.data.questionnaire)

        return dispatch({
          type: FETCH_QUESTIONS_TRANSLATIONS,
          payload: { isReady: true, language: language }
        })
      })
      .catch(() => {})
  }
}

export function answerWopiQuestion(uuid, questions, activeQuestionIndex, questionId, answer) {
  const indexForQuestion = questions.findIndex(q => q.id == questionId)

  const answeredQuestion = questions.get(indexForQuestion)
  answeredQuestion.answer = answer

  const questionsWithNewAnswer = questions.update(indexForQuestion, q => answeredQuestion)
  const nextActiveQuestionIndex = activeQuestionIndex + 1

  return function d(dispatch) {
    dispatch({ type: PRE_ANSWER_QUESTION, payload: answer })

    const payload = {
      activeQuestionIndex: nextActiveQuestionIndex,
      questions: questionsWithNewAnswer
    }

    return wopiService
      .answerWopiQuestion(uuid, questionsWithNewAnswer, nextActiveQuestionIndex)
      .then(() => {
        setTimeout(() => dispatch({ type: ANSWER_QUESTION, payload: payload }), 500)
      })
      .catch(e => dispatch({ type: QUESTIONNAIRE_ERROR, payload: true }))
  }
}

export function goToNextPhase() {
  return function d(dispatch) {
    dispatch({ type: NEXT_PHASE })
  }
}

export function submitPersonalAndStatisticalInformation(uuid, givenName, familyName, age, sex) {
  return function d(dispatch) {
    return wopiService
      .savePersonalInformation(uuid, givenName, familyName, age, sex)
      .then(response => {
        dispatch({
          type: SUBMIT_PERSONAL_INFORMATION,
          payload: {
            personalInformation: {
              givenName: givenName,
              familyName: familyName,
              age: age,
              sex: sex
            }
          }
        })

        goToNextPhase()(dispatch)
      })
  }
}

export function startQuestionnaire(uuid) {
  return dispatch => {
    wopiService.startWopi(uuid).then(() => dispatch({ type: START_QUESTIONNAIRE }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/wopi-questionnaire.js